<div class="w-full h-fit bg-black">
  <div
    class="w-full max-w-[1280px] mx-auto h-fit md:px-[40px] py-[64px] md:py-[128px] flex flex-col gap-[32px] md:gap-[64px] justify-center items-center"
  >
    <div
      class="px-[20px] md:px-0 text-[20px] leading-7 md:text-[32px] md:leading-12 font-bold text-[var(--p-primary-400)]"
    >
      {{ 'HISTORY' }}
    </div>

    <div
      class="px-[20px] md:px-0 text-[32px] leading-12 md:text-[48px] md:leading-16 font-bold text-[var(--p-primary-50)] text-center"
    >
      {{ 'home.history' | translate }}
    </div>

    <!--  TimeLine DeskTop, Tablet   -->
    <div class="timeline-desktop">
      <div class="line"></div>
      <div class="rows">
        @for (item of historyList; track $index) {
          @if ($index % 2 === 0) {
            <div class="left">
              <div class="history-arr">
                <div class="year">{{ item.year }}</div>
                @for (history of item.history; track $index) {
                  <div class="history-item">{{ history }}</div>
                }
              </div>
            </div>
            <div class="dot"></div>
            <div class="right"></div>
          } @else {
            <div class="left"></div>
            <div class="dot"></div>
            <div class="right">
              <div class="history-arr">
                <div class="year">{{ item.year }}</div>
                @for (history of item.history; track $index) {
                  <div class="history-item">{{ history }}</div>
                }
              </div>
            </div>
          }
        }
      </div>
      <div class="h-[64px] relative linear-gradient"></div>
    </div>

    <!--  TimeLine Mobile   -->
    <div class="md:hidden flex w-full">
      <ngx-flicking [options]="flickingOptions" class="w-full h-fit pl-[20px]">
        @for (item of historyListReverse; track item.year; let i = $index) {
          <div class="w-full bg-black" flicking-panel>
            <div class="relative flex items-center mb-[16px]">
              <div
                class="w-[12px] h-[12px] rounded-[999px] bg-black border border-[var(--p-primary-600)]"
              ></div>
              <div class="w-full h-[1px] bg-[var(--p-primary-600)]"></div>
              @if (i === historyListReverse.length - 1) {
                <div class="w-[40px] h-[12px] absolute right-0 linear-gradient-horizontal"></div>
              }
            </div>

            <div class="pr-[20px] h-[24px] flex justify-between items-center mb-[32px]">
              <div
                class="text-[16px] text-[var(--p-primary-50)] font-bold"
                style="transform: translateY(1px)"
              >
                {{ item.year }}
              </div>

              @if (i !== historyListReverse.length - 1) {
                <div
                  (click)="moveTo(getNextYear(item.year))"
                  class="h-[24px] flex gap-[4px] text-[16px] text-[var(--p-primary-600)] font-bold items-center"
                >
                  <div style="transform: translateY(1px)">{{ getNextYear(item.year) }}</div>
                  <img
                    alt="arrow"
                    class="w-[20px] h-[20px]"
                    src="/images/common/arrow-forward-outline.svg"
                  />
                </div>
              }
            </div>

            <div class="pr-[20px] flex flex-col gap-[16px]">
              @for (history of item.history; track $index) {
                <div class="text-[var(--p-primary-200)] text-[14px]">{{ history }}</div>
              }
            </div>
          </div>
        }
      </ngx-flicking>
    </div>
  </div>
</div>
